/* ══════════════════════════════════════════════════════════════════
   Prezently — pz7.js (warstwa „clean", 25.09)
   1) Dodawanie do koszyka z kart pz-card (produkty z jednym wariantem) → szuflada Shrine.
   2) Iskierki i płatki śniegu przy dodaniu produktu do koszyka.
      Czysto dekoracyjne: nie blokuje kliknięcia, znika po ~1,3 s,
      wyłączone przy „ogranicz ruch".
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__pz7) return;
  window.__pz7 = true;

  /* 1) karta pz-card: „Dodaj pod choinkę” bez przeładowania strony */
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('[data-pz-card-add]') : null;
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button');
    var t = btn ? btn.querySelector('span') : null;
    var stary = t ? t.textContent : '';
    var drawer = document.querySelector('cart-drawer');
    var fd = new FormData(f);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      fd.append('sections', drawer.getSectionsToRender().map(function (x) { return x.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(btn);
    }
    if (btn) btn.disabled = true;
    if (t) t.textContent = 'Dodaję…';
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'blad');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function () {
      if (t) t.textContent = 'Spróbuj ponownie';
      setTimeout(function () { if (t) t.textContent = stary; }, 2200);
      stary = null;
    }).then(function () {
      if (btn) btn.disabled = false;
      if (t && stary !== null) t.textContent = stary;
    });
  });
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var GWIAZDKA = '<svg viewBox="0 0 24 24"><path fill="#D9AE55" d="M12 1.5c.6 5.6 4.9 9.9 10.5 10.5-5.6.6-9.9 4.9-10.5 10.5-.6-5.6-4.9-9.9-10.5-10.5C7.1 11.4 11.4 7.1 12 1.5Z"/></svg>';
  var PLATEK = '<svg viewBox="0 0 24 24" fill="none" stroke="#8FB3C7" stroke-width="2" stroke-linecap="round">' +
    '<path d="M12 2v20M3.3 7l17.4 10M3.3 17L20.7 7M9 3.5l3 2.5 3-2.5M9 20.5l3-2.5 3 2.5"/></svg>';
  var SELEKTORY = '#pz-atc, [data-pz-sticky-btn], .quick-add__submit, .product-form__submit, button.pz-card__btn';

  function wybuch(el) {
    var r = el.getBoundingClientRect();
    if (!r.width) return;
    var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
    var ile = 16;
    for (var i = 0; i < ile; i++) {
      var s = document.createElement('span');
      s.className = 'pz-iskra7';
      s.innerHTML = (i % 5 === 0 || i % 5 === 3) ? PLATEK : GWIAZDKA;
      var rozm = 8 + Math.random() * 9;
      s.style.width = s.style.height = rozm + 'px';
      s.style.left = (cx + (Math.random() - 0.5) * r.width * 0.6) + 'px';
      s.style.top = (cy + (Math.random() - 0.5) * r.height * 0.4) + 'px';
      document.body.appendChild(s);
      var kat = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.1;
      var dl = 40 + Math.random() * 80;
      var dx = Math.cos(kat) * dl, dy = Math.sin(kat) * dl;
      var obr = (Math.random() - 0.5) * 240;
      var czas = 900 + Math.random() * 500;
      if (s.animate) {
        var a = s.animate([
          { transform: 'translate(0,0) scale(.3) rotate(0deg)', opacity: 0 },
          { transform: 'translate(' + dx * 0.35 + 'px,' + dy * 0.35 + 'px) scale(1) rotate(' + obr * 0.4 + 'deg)', opacity: 1, offset: 0.25 },
          { transform: 'translate(' + dx + 'px,' + (dy + 30) + 'px) scale(.7) rotate(' + obr + 'deg)', opacity: 0 }
        ], { duration: czas, easing: 'cubic-bezier(.2,.7,.3,1)' });
        a.onfinish = (function (n) { return function () { if (n.parentNode) n.parentNode.removeChild(n); }; })(s);
      } else {
        setTimeout((function (n) { return function () { if (n.parentNode) n.parentNode.removeChild(n); }; })(s), 1200);
      }
    }
  }

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest(SELEKTORY) : null;
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return;
    wybuch(el);
  }, true);
})();
